import React, { useEffect, useRef, useState } from "react";
import TimeField from "react-simple-timefield";
import { appTheme } from "../../../theme/Theme";
import AppText from "../AppText/AppText";

interface TimeInputProps {
	selectedTime?: string;
	onChange: (time: string) => void;
	isValid?: boolean;
	onFocus?: any;
	onClick?: any;
	inputRef?: any;
	inputHeight?: string;
	textColor?: string;
	placeHolderTime?: string;
	disabled?: boolean;
	margin?: string;
	autoFocus?: boolean;
	onEnter?: (e: KeyboardEvent) => void;
	isCustom?: boolean;
	label?: string;
}

const TimeInput = React.forwardRef<HTMLDivElement, TimeInputProps>(
	(
		{
			selectedTime,
			onChange,
			isValid = true,
			onFocus,
			onClick,
			inputRef,
			inputHeight,
			textColor,
			placeHolderTime,
			disabled,
			margin,
			autoFocus = false,
			onEnter,
			isCustom = false,
			label = "",
		},
		ref
	) => {
		const [time, setTime] = useState<string>(selectedTime || placeHolderTime || "");

		const timeFieldRef = useRef<HTMLInputElement>(null);

		const handleTimeField = (e: any) => {
			setTime(e.target.value);
		};

		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === "Enter") {
				onEnter && onEnter(e);
			}
		};

		useEffect(() => {
			if (selectedTime) {
				setTime(selectedTime);
			}
		}, [selectedTime]);

		useEffect(() => {
			onChange(time);
		}, [time]);

		useEffect(() => {
			if (disabled && timeFieldRef.current) {
				timeFieldRef.current.disabled = true;
			}
		}, [timeFieldRef, disabled]);

		useEffect(() => {
			if (timeFieldRef.current && autoFocus) {
				timeFieldRef.current.focus();
				timeFieldRef.current.select();
			}
		}, [timeFieldRef, autoFocus]);

		return (
			<>
				{isCustom ? (
					<div
						ref={ref || inputRef}
						onFocus={onFocus}
						onClick={onClick}
						style={{
							border: "1px solid #ccc",
							padding: "0px 6px",
							display: "inline-flex",
							alignItems: "center",
							borderRadius: "2px",
							fontSize: "20px",
							fontFamily: "sans-serif",
							flexDirection: "row",
						}}
					>
						<AppText size="xxs" color="grayText" weight="regular">
							{label}
						</AppText>
						<TimeField
							style={{
								border: `1px solid  ${isValid ? "#dbdbdb" : "hsl(var(--danger))"}`,
								height: inputHeight ? inputHeight : "2.3125rem",
								fontSize: appTheme.fontSizes.FONT_SIZE_M,
								width: "4rem",
								borderWidth: 0,
								padding: "0.375rem 0.75rem",
								color: textColor ? textColor : "black",
								borderRadius: 1,
								fontFamily: "Roboto",
								backgroundColor: `${isValid ? "white" : "#FFF5F5"}`,
								opacity: disabled ? 0.6 : 1,
								margin,
							}}
							value={time}
							onChange={(e) => (disabled ? setTime(time) : handleTimeField(e))}
							// @ts-ignore
							inputRef={timeFieldRef}
							onKeyDown={handleKeyDown}
							showSeconds={false}
						/>
					</div>
				) : (
					<div ref={ref || inputRef} onFocus={onFocus} onClick={onClick}>
						<TimeField
							style={{
								border: `1px solid  ${isValid ? "#dbdbdb" : "hsl(var(--danger))"}`,
								height: inputHeight ? inputHeight : "2.3125rem",
								fontSize: appTheme.fontSizes.FONT_SIZE_M,
								width: 66,
								padding: "0.375rem 0.75rem",
								color: textColor ? textColor : "black",
								borderRadius: 1,
								fontFamily: "Roboto",
								backgroundColor: `${isValid ? "white" : "#FFF5F5"}`,
								opacity: disabled ? 0.6 : 1,
								margin,
							}}
							value={time}
							onChange={(e) => (disabled ? setTime(time) : handleTimeField(e))}
							// @ts-ignore
							inputRef={timeFieldRef}
							onKeyDown={handleKeyDown}
							showSeconds={false}
						/>
					</div>
				)}
			</>
		);
	}
);

TimeInput.displayName = "TimeInput";

export default TimeInput;
